export const CREW_LEAD_SUMMARY_LS_PREFIX = "crewLeadSummary";
export const FILTER_BY_CLASS_ID = "filterClass";
export const CREW_LEAD_SUMMARY_FILTER_BY_CLASS_LS = `${CREW_LEAD_SUMMARY_LS_PREFIX}_${FILTER_BY_CLASS_ID}`;

export const CREW_LEAD_SUMMARY_FILTERS_SS = `crewLeadSummaryFilters`;

export const SummaryViewId = "timeCards";
export const DetailsViewId = "audit";